import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AssessmentProject } from "../../models/assessment-project";

@Component({
    selector: 'app-delete-project-warning',
    templateUrl: './delete-project-warning.component.html',
    styleUrls: ['./delete-project-warning.component.scss'],
    standalone: false
})
export class DeleteProjectWarningComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DeleteProjectWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
  }
  cancel(){
    this.dialogRef.close(false);
  }
  deleteProject() {
    this.dialogRef.close(true);
  }

}
